import React from "react";
import "../App.css";
import { Row, Col, Image, Layout, Layout as AntdLayout } from "antd";
import "antd/dist/antd.css";
import styled from "@emotion/styled";
import Footer from "../components/Footer";
import HeaderEn from "../components/HeaderEn";
import Kalendar from "../assets/Kalendar.jpg";

const CustomContent = styled(AntdLayout.Content)({
  backgroundColor: "lightyellow",
  color: "lightblack",
  textAlign: "left",
  paddingLeft: "5%",
  paddingRight: "5%",
  paddingTop: "3%",
  minHeight: "900px",
  "@media (max-width: 1200px)": {
    paddingTop: "5%",
    minHeight: "1000px",
  },
  "@media (max-width: 992px)": {
    paddingTop: "5%",
    minHeight: "1200px",
  },
  "@media (max-width: 768px)": {
    paddingTop: "6%",
    minHeight: "900px",
  },
  "@media (max-width: 576px)": {
    paddingTop: "6%",
    minHeight: "800px",
  },
  "@media (max-width: 480px)": {
    paddingTop: "8%",
    minHeight: "750px",
  },
  "@media (max-width: 380px)": {
    paddingTop: "8%",
    minHeight: "650px",
  },
});
const Maintext = styled(AntdLayout.Content)({
  backgroundColor: "transparent",
  fontColor: "lightblack",
  textAlign: "left",
  fontSize: "26px",
  fontWeight: "bold",
  "@media (max-width: 992px)": {
    paddingLeft: "6%",
  },
  "@media (max-width: 768px)": {
    paddingLeft: "7%",
  },
  "@media (max-width: 576px)": {
    paddingLeft: "8%",
  },
  "@media (max-width: 480px)": {
    paddingLeft: "8%",
  },
});

const FruitCalendar_en: React.FC = (): JSX.Element => (
  <Layout>
    <HeaderEn />
    <CustomContent>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Maintext>
            Fruit Calendar
          </Maintext>
          <br />
          <a>
            <Image
              src={Kalendar}
              className="fruitcalendar"
              alt="fruitcalendar"
              style={{ maxWidth: "700px"}}
            />
          </a>
          <p style={{paddingTop:"5px"}}>(Click on the image to zoom)</p>
        </Col>
      </Row>
    </CustomContent>
    <Footer />
  </Layout>
);

export default FruitCalendar_en;
